import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"

import Components from "../components/components.js"

const GlobalComponentEditable = ({ blok }) => {
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"
  const globalComponentStories = useStaticQuery(graphql`
    query GlobalComponentQuery {
      allStoryblokEntry(
        filter: { default_full_slug: { regex: "/^globale-elemente/" } }
      ) {
        nodes {
          uuid
          lang
          content
        }
      }
      fallback: allStoryblokEntry(
        filter: { full_slug: { regex: "/^globale-elemente/" } }
      ) {
        nodes {
          uuid
          lang
          content
        }
      }
    }
  `)

  const filterLang =
    blok.currentLanguage === defaultLang ? "default" : blok.currentLanguage
  let itemId = blok.body

  let defaultStories = globalComponentStories.allStoryblokEntry.nodes

  const allStories = defaultStories.length
    ? defaultStories
    : globalComponentStories.fallback.nodes

  let itemInAllLanguages = allStories.filter((node) => node.uuid === itemId)

  let currentLanguageItem = itemInAllLanguages.filter(
    (node) => node.lang === filterLang
  )[0]

  let customFallbackLang = "en"

  itemInAllLanguages = itemInAllLanguages.sort((firstEl, secondEl) => {
    if (firstEl.lang === secondEl.lang) {
      return 0
    }
    if (firstEl.lang === customFallbackLang) {
      return -1
    }
    return 0
  })

  let fallbackItem = itemInAllLanguages[0]

  let globalComponentData = currentLanguageItem

  if (!currentLanguageItem) {
    globalComponentData = fallbackItem
  }

  if (globalComponentData && typeof globalComponentData.content === "string") {
    globalComponentData.content = JSON.parse(globalComponentData.content)
  }

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      {globalComponentData && globalComponentData.content ? (
        React.createElement(Components(globalComponentData.content.component), {
          key: globalComponentData.content._uid,
          blok: {
            ...globalComponentData.content,
            currentLanguage: blok.currentLanguage,
          },
        })
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default GlobalComponentEditable
